export default __webpack_public_path__ + "static/media/1.e137a68f.svg";